exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".to-rate{\n    cursor: pointer;\n    padding: 0 3px;\n}\n.fa-star-o{\n    color: orange;\n}\n.fa-star{\n    color: orange;\n}\n.fa-star-half-o{\n    color: orange;\n}\n.to-display{\n    padding: 0 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/star-rating/star-rating.component.css
// module id = 845
// module chunks = 0